import { __assign, __read, __rest } from "tslib";
import React, { useContext, useImperativeHandle, forwardRef } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { Icon } from "../icon";
import { useDefault } from "../_util/use-default";
import { callBoth } from "../_util/call-both";
/**
 * Check 组件支持使用 CheckContext 进行状态托管
 */
export var CheckContext = React.createContext(null);
var DEFAULT_COLOR = "#006EFF";
export var Check = forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? DEFAULT_COLOR : _b, restProps = __rest(_a, ["color"]);
    // 支持从 Context 注入
    var context = useContext(CheckContext);
    var props = restProps;
    if (context) {
        props = context.inject(restProps);
    }
    var _c = props.defaultChecked, defaultChecked = _c === void 0 ? false : _c, checked = props.checked, onCheckedChange = props.onChange, radio = props.radio, children = props.children, _d = props.disabled, disabled = _d === void 0 ? false : _d, block = props.block, type = props.type, onClick = props.onClick, className = props.className, style = props.style, htmlProps = __rest(props, ["defaultChecked", "checked", "onChange", "radio", "children", "disabled", "block", "type", "onClick", "className", "style"]);
    var _e = __read(useDefault(checked, defaultChecked, onCheckedChange), 2), value = _e[0], onChange = _e[1];
    useImperativeHandle(ref, function () { return ({
        trigger: function (event) {
            if (disabled) {
                return;
            }
            onChange(!value, { event: event });
        },
    }); }, [onChange, value, disabled]);
    return (React.createElement(View, __assign({ className: classNames("tea-checkbox-wrap", className, {
            "is-checked": value,
            "is-disabled": disabled,
            "tea-checkbox__wrap--block": block,
            "tea-checkbox__wrap--agreement": type === "agreement",
            "tea-checkbox__wrap--outline": type === "button",
        }), style: style, onClick: callBoth(onClick, function (event) {
            event.stopPropagation();
            if (disabled) {
                return;
            }
            onChange(!value, { event: event });
        }) }, htmlProps),
        type !== "button" && (React.createElement(View, { className: classNames("tea-checkbox", {
                "tea-checkbox--square": type === "square" || type === "agreement",
            }) }, value && (React.createElement(Icon, { name: "check", color: "#fff", size: type === "agreement" ? 32 : 40 })))),
        React.createElement(View, { className: "tea-checkbox__label" }, children)));
});
//# sourceMappingURL=Check.js.map